// import { toast } from 'react-toastify';
//API for Worlds
import { WorldConstants } from '../_constants';
import { WorldService } from '../_services';

export const WorldActions = {
  loadFromChronicle,
  getSubGroups,
};

function loadFromChronicle(payload) {
  return {
    type: WorldConstants.POPULATE_WORLD,
    world: payload,
  };
}

function getSubGroups(worldID) {
  return (dispatch) => {
    dispatch(request({ world: worldID }));

    return WorldService.getSubGroups(worldID).then(
      (subGroups) => {
        dispatch(success(subGroups));
        return subGroups;
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(params) {
    return {
      type: WorldConstants.GET_SUBGROUPS_REQUEST,
      params: params,
    };
  }

  function success(subGroups) {
    return {
      type: WorldConstants.GET_SUBGROUPS_SUCCESS,
      groups: subGroups,
    };
  }

  function failure(error) {
    return {
      type: WorldConstants.GET_SUBGROUPS_FAILURE,
      error,
    };
  }
}
